import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ProjectFilePickerInputModule } from '@portal-core/project-files/components/project-file-picker-input/project-file-picker-input.module';
import { InsertVariableDialogModule } from '@portal-core/project-files/variables/components/insert-variable-dialog/insert-variable-dialog.module';
import { ArrayToStringModule } from '@portal-core/ui/array/directives/array-to-string/array-to-string.module';
import { HelpIconButtonModule } from '@portal-core/ui/button/components/help-icon-button/help-icon-button.module';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { TopicPropertiesComponent } from './topic-properties.component';


@NgModule({
  declarations: [
    TopicPropertiesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    McColorModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    DropdownArrowModule,
    HelpIconButtonModule,
    ArrayToStringModule,
    ProjectFilePickerInputModule,
    InsertVariableDialogModule,
    FormControlErrorMessageModule,
  ],
  exports: [
    TopicPropertiesComponent
  ]
})
export class TopicPropertiesModule { }
